<div class="card border-0 shadow-sm h-100">
    <div class="card-body text-center">
        <h4 class="mb-4 text-secondary">{{ title }}</h4>
        <ng-content></ng-content>
    </div>
</div>
